var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.1527,
    r: 9.5,
    stroke: "#7D899D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1318 14.35C11.141 13.8077 11.2025 13.3793 11.3164 13.0648C11.4303 12.7504 11.6628 12.4017 12.0137 12.0189L12.9092 11.0961C13.292 10.6631 13.4834 10.1983 13.4834 9.70154C13.4834 9.22302 13.3581 8.84932 13.1074 8.58044C12.8568 8.30701 12.4922 8.17029 12.0137 8.17029C11.5488 8.17029 11.1751 8.29333 10.8926 8.53943C10.61 8.78552 10.4688 9.11593 10.4688 9.53064H9.2041C9.21322 8.79236 9.47526 8.19763 9.99023 7.74646C10.5098 7.29073 11.1842 7.06287 12.0137 7.06287C12.875 7.06287 13.5449 7.29529 14.0234 7.76013C14.5065 8.22042 14.748 8.85388 14.748 9.66052C14.748 10.458 14.3789 11.2442 13.6406 12.0189L12.8955 12.7572C12.5628 13.1263 12.3965 13.6573 12.3965 14.35H11.1318ZM11.0771 16.517C11.0771 16.3119 11.1387 16.141 11.2617 16.0043C11.3893 15.863 11.5762 15.7924 11.8223 15.7924C12.0684 15.7924 12.2552 15.863 12.3828 16.0043C12.5104 16.141 12.5742 16.3119 12.5742 16.517C12.5742 16.722 12.5104 16.8929 12.3828 17.0297C12.2552 17.1618 12.0684 17.2279 11.8223 17.2279C11.5762 17.2279 11.3893 17.1618 11.2617 17.0297C11.1387 16.8929 11.0771 16.722 11.0771 16.517Z",
    fill: "#7D899D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.fbf81f0ac97e530dfcb914121dfca6e8.svg";
export { ForwardRef as ReactComponent };